import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';
import { SystemNoteType } from '../../../Domain/Models/Catalogue/Generic/NoteType';

export default class AuditTrailRemindersCriteria extends Model.CriteriaBase {
    static typeName = "AuditTrailRemindersCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date = DateUtils.today();

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date = DateUtils.today();

    public grouping: SystemNoteType | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<AuditTrailRemindersCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Audit Trail Reminders Criteria";
    }
}